import { TenantInfoApplications } from './tenant-into-applications';

export class TenantInfo {
  public id: string;
  public description: string;
  public name: string;
  public applications: TenantInfoApplications[];
  public active: boolean;
  public iSignEnabled: boolean;
}
